module.exports = __webpack_public_path__ + "img/LI.962941c2.svg";